import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { LOCATION_TYPE_CATEGORY_NODE_FRAGMENT } from '../fragments'

const DELETE_LOCATION_TYPE_MUTATION = gql`
  mutation deleteLocationType($id: ID!) {
    deleteLocationType(id: $id) {
      results {
        ...LocationTypeCategoryNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${LOCATION_TYPE_CATEGORY_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default DELETE_LOCATION_TYPE_MUTATION
